(function () {
  const slideshow = () => {
    $(".slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".slideshow");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const speed = box.data("speed") * 1000;
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
            waitForTransition: true,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: box.data("parallax"),
        effect: box.data("effect"),
        speed: speed,
        loop: false,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,
        creativeEffect: {
          prev: {
            shadow: false,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        flipEffect: {
          slideShadows: false,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: "true",
          type: "bullets",
          renderBullet: function (activeIndex, className) {
            return (
              '<span class="' +
              className +
              '">' +
              "<em>" +
              activeIndex +
              "</em>" +
              "<i></i>" +
              "<b></b>" +
              "</span>"
            );
          },
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
      swiper.on("slideChange", function () {
        box.css("--bullet-duration", `${delay + speed}ms`);
      });
      swiper.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      swiper.on("slideChange", function () {
        colorScheme(this);
      });

      function colorScheme(context) {
        //const parent = $(context.el).parent();
        const parent = box.find(".slideshow-bottom");
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [parent[0]];
        const colorScheme = $(activeSlide)
          .find(".slideshow-slide")
          .data("color-scheme");
        changeItems.forEach((item) => {
          if (!item) return "";
          const classes = item.classList;
          for (let className of classes) {
            if (/color-background-\d+$/.test(className)) {
              item.classList.remove(className);
            }
          }
          item.classList.add(colorScheme);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();

(function () {
  // Full-screen ("Full screen"/large) slideshows must fill the viewport exactly
  // below the top bars. --header-height and --announcement-height only match the
  // real bars at desktop widths, so on mobile the CSS subtraction is off by a
  // few pixels. Measure the actually-rendered top bars and expose the total as
  // --slideshow-chrome; the stylesheet subtracts it from 100dvh on mobile.
  const updateSlideshowChrome = () => {
    const slideshows = document.querySelectorAll(".slideshow.large");
    if (!slideshows.length) return;

    const header = document.querySelector(".shopify-section-header");
    const announcementBar = document.querySelector(".announcement-bar");
    const announcement = announcementBar
      ? announcementBar.closest(".shopify-section") || announcementBar
      : null;

    // A header in "overlay" mode sits on top of the slide rather than above it,
    // so it takes no vertical space and must not be subtracted.
    const headerInFlow =
      header && !header.classList.contains("header-overlay");

    const chrome =
      (headerInFlow ? header.offsetHeight : 0) +
      (announcement ? announcement.offsetHeight : 0);

    slideshows.forEach((slideshow) => {
      slideshow.style.setProperty("--slideshow-chrome", `${chrome}px`);
    });
  };

  let scheduled = false;
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      updateSlideshowChrome();
    });
  };

  if (document.readyState !== "loading") {
    scheduleUpdate();
  } else {
    document.addEventListener("DOMContentLoaded", scheduleUpdate);
  }
  window.addEventListener("load", updateSlideshowChrome);
  window.addEventListener("resize", scheduleUpdate);
  window.addEventListener("orientationchange", scheduleUpdate);
  document.addEventListener("shopify:section:load", scheduleUpdate);
})();
